// extracted by mini-css-extract-plugin
module.exports = {"page":"xt_page__kBxEb","nav":"xt_nav__lOTp4","main":"xt_main___xmUd","mainNoNav":"xt_mainNoNav__wm9EZ","mainFixedNav":"xt_mainFixedNav__FgpRI","foot":"xt_foot__MYwL3"};